import { FocusOrigin } from '@angular/cdk/a11y';
import { MatSidenav, MatSidenavContainer } from '@angular/material/sidenav';
import { Observable } from 'rxjs';

export abstract class SiteSidenavRefBase {
   private sidenav: MatSidenav;

   private container: MatSidenavContainer;

   open(openedVia?: FocusOrigin): void {
      this.sidenav.open(openedVia);
   }

   close(): void {
      this.sidenav.close();
   }

   get backdropClick(): Observable<void> {
      return this.container.backdropClick;
   }

   toggle(isOpen: boolean = !this.sidenav.opened, openedVia: FocusOrigin = 'program'): void {
      this.sidenav.toggle(isOpen, openedVia);
   }

   get openedStream(): Observable<boolean> {
      return this.sidenav.openedChange;
   }

   initialize(container: MatSidenavContainer, sidenav: MatSidenav): void {
      this.container = container;
      this.sidenav = sidenav;
   }
}
